import { render, staticRenderFns } from "./Preventiva.vue?vue&type=template&id=37ddc004"
import script from "./Preventiva.vue?vue&type=script&lang=js"
export * from "./Preventiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports